// IIFE
(($) => {

  function resizeGL($el) {
    $el.height($('img:visible',$el).height());
    $('.title-galeria',$el.parent()).html($('img:visible',$el).data('title'));
  }

  $('.cke-ig').each(function() {
      var $el = $(this);
      $el.removeClass('cke-ig');
      $el.addClass('imagens-galeria-plus');
      $el.wrap('<div class="galeria-imagens-container"></div>');
      $('img',$el).removeAttr('width').removeAttr('height').hide();
    $('img',$el).each(function() {
      $(this).data('title',$(this).attr('title'));
      $(this).attr('title',''); // pra tirar o hover
    });
      $('img',$el).first().show();
      $('img',$el).on('load',() => {
        resizeGL($el);
      });
      if ($('img',$el).length > 1) {
        var $btn = $(`
<div class="title-galeria"></div>
<div class="image-controller">
<div class="ctl anterior"></div>
<div class="ctl proxima"></div>
</div>`);
        var tanoefeito = false;
        $btn.on('click','.ctl',function() {
          if (tanoefeito) return;
          tanoefeito = true;
          var visible = $('img:visible',$el);
          var next;
          if ($(this).hasClass('anterior')) {
            next = visible.prev('img');
            if (next.length == 0) {
              next = $('img',$el).last();
            }
          } else {
            next = visible.next('img');
            if (next.length == 0) {
              next = $('img',$el).first();
            }
          }
          visible.fadeOut();
          next.fadeIn(function() {
            tanoefeito = false;
            resizeGL($el);
          });
        });
        $el.parent().append($btn);
      }
  });
  function callPlayer(iframe,func, args) {
    console.log(iframe,func);
    iframe.contentWindow.postMessage(JSON.stringify({
      'event': 'command',
      'func': func,
      'args': args || []
      }), '*');
  };
  $('iframe.video_embed').wrap("<div class='video-container'></div>");

  $('iframe.video_embed').each(function() {
    var src = $(this).get(0).src;
    if (!src.match(/\?/)) {
      src += '?';
    }
    src += '&enablejsapi=1';
    $(this).get(0).src = src;
  })
  $('.video-container').on('click',function() {
    if ($(this).hasClass('active')) return;
    $(this).addClass('active');
    callPlayer($(this).find('iframe').get(0),'playVideo')
  });

})(jQuery);
